import Alpine from "alpinejs";
// import UI from "@alpinejs/ui";
// import Mask from "@alpinejs/mask";
import Intersect from "@alpinejs/intersect";
// import Persist from "@alpinejs/persist";
// import Focus from "@alpinejs/focus";
// import Collapse from "@alpinejs/collapse";
// import Morph from "@alpinejs/morph";

// Alpine.plugin(UI);
// Alpine.plugin(Mask);
Alpine.plugin(Intersect);
// Alpine.plugin(Persist);
// Alpine.plugin(Focus);
// Alpine.plugin(Collapse);
// Alpine.plugin(Morph);

window.Alpine = Alpine;

Alpine.start();


import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import "photoswipe/style.css";

const lightbox_page_our_coach_section0_images = new PhotoSwipeLightbox({
  gallery: "#page_our_coach_section0_images",
  children: "a",
  pswpModule: PhotoSwipe,
  imageClickAction: 'next',
  tapAction: 'next',
});
lightbox_page_our_coach_section0_images.init();

const lightbox_page_destination_section0_images = new PhotoSwipeLightbox({
  gallery: "#page_destination_section0_images",
  children: "a",
  pswpModule: PhotoSwipe,
  imageClickAction: 'next',
  tapAction: 'next',
});
lightbox_page_destination_section0_images.init();
